import EventsAgenda from './EventsAgenda.vue';

export default EventsAgenda;
